// src/pages/ProductReplaceRecord/ProductReplaceRecordThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../apiservice/apis";
import { replaceDeleteApi } from "../../apiservice/sales";

export const fetchProductReplaceRecord = createAsyncThunk(
  "productReplaceRecord/fetch",
  async ({ selectedFilterType, selectedRecordType, filters }, { rejectWithValue }) => {
    try {
      let url = "/sales/get-product-replace-record";
      if (selectedRecordType === "with item") {
        url = "/sales/get-replace-record-with-details";
      }

      const payload = {
        selectedFilterType: selectedFilterType || null,
        selectedRecordType: selectedRecordType || null,
        customerId: selectedFilterType === "By Customer" ? filters.customerId || null : null,
        employeeId: selectedFilterType === "By Employee" ? filters.employeeId || null : null,
        itemId: selectedFilterType === "By Item" ? filters.itemId || null : null,
        fromDate: filters.fromDate || null,
        toDate: filters.toDate || null,
        userId: selectedFilterType === "By User" ? filters.userId || null : null,
      };

      const res = await postData(url, payload);

      let mapped = [];

      if (selectedRecordType === "with item") {
        mapped = res.data.flatMap((row, idx) =>
          (row.mciDetails || []).map((item, j) => ({
            id: `${row.replace_id}-${item.item_id}-${j}`,
            vch_no: row.voucher_no,
            date: row.created_date,
            customer: row.customer_name || row.customer_id,
            employee: row.employee_name,
            createdBy: row.full_name,
            mode: row.mode || "",
            narration: row.narration || "",  // ✅ also carry narration
            item: item.item_name,
            rate: Number(item.return_rate || 0),
            discount: Number(item.item_discount_per || 0),
            vat: Number(item.item_tax_per || 0),
            qty: Number(item.return_item_qty || 0),
            total: Number(item.return_item_total || 0),
            unitDetails: `Master U. Qty = ${item.return_item_qty || 0}, Base U. Qty = ${item.return_item_qty || 0}`,
          }))
        );
      } else {
        mapped = res.data.map((row) => ({
          id: row.replace_id,
          vch_no: row.voucher_no,
          date: row.created_date,
          customer: row.customer_name || row.customer_id,
          employee: row.employee_name,
          createdBy: row.full_name,
          narration: row.narration || "",   // ✅ map narration for summary
          subtotal: Number(row.total_cost || 0),
          discount: 0,
          vat: Number(row.total_tax || 0),
          service: Number(row.labour_cost || 0) + Number(row.others_cost || 0),
          total: Number(row.total_cost || 0),
          paid: Number(row.paid_amount || 0),
          due: Number(row.due_amount || 0),
        }));
      }

      return mapped;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// 🗑️ Delete product replace record
export const deleteProductReplaceRecord = createAsyncThunk(
  "productReplaceRecord/delete",
  async (replaceId, { rejectWithValue }) => {
    try {
      const res = await replaceDeleteApi({ replace_id: replaceId });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
